import { useQuery } from '@apollo/client/react';
import { SplitContext } from '@splitsoftware/splitio-react';
import { useContext } from 'react';

import { SelfDocument } from '../graphql/types';

export enum SplitFlags {
  SPA_TEST_DATA_SERVICE = 'spa-test-data-service',
  SPA_FEATURE_MANAGEMENT = 'admin-feature-management',
  SPA_LAUNCH_MANAGER = 'admin-launch-manager',
}

type FeatureFlags = Record<SplitFlags, boolean>;

export const useFeatureFlags = () => {
  const { client, isReady } = useContext(SplitContext) || {};
  const { data } = useQuery(SelfDocument, {
    fetchPolicy: 'cache-first',
  });
  const { id: userId = '', isAdmin = false, email = '' } = data?.self ?? {};

  const attributes = {
    userId,
    isAdmin,
    email,
  };

  const treatments =
    client?.getTreatmentsWithConfig(Object.values(SplitFlags), attributes) ??
    {};
  const normalizedTreatments = {} as FeatureFlags;

  Object.keys(treatments).forEach((id) => {
    normalizedTreatments[id as unknown as SplitFlags] =
      treatments[id].treatment === 'on';
  });

  return { isReady, flags: normalizedTreatments };
};
